import React from 'react';
import ReactDOM from 'react-dom';
import '../styles/glass-modal.css';

/* GlassModal — Liquid-Glass modal, portaled to <body> so the fixed overlay
   is never trapped by the .content-wrapper stacking context. Compound API:
   GlassModal + GlassModalHeader / GlassModalBody / GlassModalFooter. */

const SIZE_MAX = { sm: 380, md: 540, lg: 820, xl: 1140, fluid: '96vw' };

export const GlassModal = ({ isOpen, toggle, size, className, children, ...rest }) => {
  // While a modal is open, drop the app-shell backdrop-filter (it's hidden
  // behind the overlay anyway) — stacking a full-screen scrim over the
  // blurred shell is very expensive to composite.
  React.useEffect(() => {
    if (!isOpen) return undefined;
    document.body.classList.add('gm-open');
    return () => document.body.classList.remove('gm-open');
  }, [isOpen]);

  if (!isOpen) return null;
  const maxWidth = SIZE_MAX[size] || 540;
  return ReactDOM.createPortal(
    <div className="gm-overlay" onClick={(e) => { if (e.target === e.currentTarget && toggle) toggle(); }}>
      <div className={['gm-card', className].filter(Boolean).join(' ')} style={{ maxWidth }} role="dialog" aria-modal="true" {...rest}>
        {children}
      </div>
    </div>,
    document.body
  );
};

export const GlassModalHeader = ({ toggle, className, children, ...rest }) => (
  <div className={['gm-header', className].filter(Boolean).join(' ')} {...rest}>
    <div className="gm-title">{children}</div>
    {toggle && (
      <button type="button" className="gm-close" aria-label="Close" onClick={toggle}>&times;</button>
    )}
  </div>
);

export const GlassModalBody = ({ className, children, ...rest }) => (
  <div className={['gm-body', className].filter(Boolean).join(' ')} {...rest}>{children}</div>
);

export const GlassModalFooter = ({ className, children, ...rest }) => (
  <div className={['gm-footer', className].filter(Boolean).join(' ')} {...rest}>{children}</div>
);

export default GlassModal;
